import { Block, Link, Typography } from '@xprog/prensa'
import NextLink from 'next/link'
import React from 'react'
import get from 'lodash/get'
import { useImageProxy } from 'hooks/useImageProxy'

const GenericWidgetWrapper = ({ data }) => {
  const link = get(data[0], 'props.children[0].props.image.byline', '')
  const title = get(data[0], 'props.children[0].props.title', '')
  const subject = get(data[0], 'props.children[0].props.subject', '')
  const colorArray = get(data[0], 'props.children[0].props.image.caption', '').split(", ");
  const imageUrl = get(data[0], 'props.children[0].props.image.url', '')
  const image = get(data[0], 'props.children[0].props.image', '')
  const imageAlt = get(data[0], 'props.children[0].props.image.caption', '')
  const imgSrc = useImageProxy(`${imageUrl}f=3x2&w=2048`, true);

  const isSameDomain = (url) => {
    try {
      const linkUrl = new URL(url);
      const windowUrl = new URL(window.location.href);
      return linkUrl.hostname === windowUrl.hostname;
    } catch (error) {
      return false; // Em caso de erro na análise da URL, assumir que não é o mesmo domínio
    }
  };

  const linkTarget = isSameDomain(link) ? '_self' : '_blank';

  const titleProps = {
    fontFamily: '$primary',
    fontSize: '26px',
    fontWeight: 700,
    lineHeight: '28px',
    color: colorArray[1],
    mt: '$2',
    mb: '$3',
    '@lg': {
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: 0.2
    },
    textAlign: 'left'
  }
  const subjectProps = {
    fontFamily: '$primary',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '24px',
    color: colorArray[1],
    mt: '$2',
    mb: '$3',
    '@lg': {
      fontSize: '18px',
      lineHeight: '22px',
      letterSpacing: 0.2
    },
    textAlign: 'left'
  }

  return (
    <Block css={{ align: ['column', 'center', 'middle'], width: '100%', background: colorArray[0], borderRadius: '5px', padding: '$2', mt:'$1', mb: '$1'}}>
      <Block css={{ align: ['column', 'left', 'middle'], width: '100%' }}>
        <Typography css={subjectProps}>
          {subject}
        </Typography>
      </Block>
      <Link
        bypass={false}
        component={NextLink}
        componentProps={{ href: link, target: linkTarget, legacyBehavior: true }}
        href={link}
        target={linkTarget}
        css={{ fontSize: 0, width: '100%' }}
      >
        <img alt={imageAlt} src={imgSrc} width={'100%'} />

        <Block css={{ align: ['column', 'left', 'middle'], width: '100%' }}>
          <Typography css={titleProps}>
            {title}
          </Typography>
        </Block>
      </Link>
    </Block>
  )
}

export default GenericWidgetWrapper
